import Image from '@atlaskit/image';
import dateLabelAnatomyLight from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-anatomy-light.png";
import dateLabelAnatomyDark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-anatomy-dark.png";
import dateLabelDo1Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-1-light.png";
import dateLabelDo1Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-1-dark.png";
import dateLabelDont1Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-1-light.png";
import dateLabelDont1Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-1-dark.png";
import dateLabelDo2Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-2-light.png";
import dateLabelDo2Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-2-dark.png";
import dateLabelDont2Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-2-light.png";
import dateLabelDont2Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-2-dark.png";
import dateLabelDo3Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-3-light.png";
import dateLabelDo3Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-3-dark.png";
import dateLabelDont3Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-3-light.png";
import dateLabelDont3Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-3-dark.png";
import dateLabelDo4Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-4-light.png";
import dateLabelDo4Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-do-4-dark.png";
import dateLabelDont4Light from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-4-light.png";
import dateLabelDont4Dark from "../../../../../../packages/design-system/date-label/constellation/index/images/date-label-dont-4-dark.png";
import * as React from 'react';
export default {
  Image,
  dateLabelAnatomyLight,
  dateLabelAnatomyDark,
  dateLabelDo1Light,
  dateLabelDo1Dark,
  dateLabelDont1Light,
  dateLabelDont1Dark,
  dateLabelDo2Light,
  dateLabelDo2Dark,
  dateLabelDont2Light,
  dateLabelDont2Dark,
  dateLabelDo3Light,
  dateLabelDo3Dark,
  dateLabelDont3Light,
  dateLabelDont3Dark,
  dateLabelDo4Light,
  dateLabelDo4Dark,
  dateLabelDont4Light,
  dateLabelDont4Dark,
  React
};